import OverViewIcon from "../Icons/OverViewIcon";
import { Outlet, useLocation, useSearchParams } from "react-router-dom";
//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import useGetHook from "../hooks/useGetHook";
import APIS from "../constant/Endpoint";
import { useEffect, useMemo, useState } from "react";
import Modal from "../Reusable/Modal";
import usePostHook from "../hooks/usePostHook";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { setEmailAccountValidationForm } from "../utils/validationSchemas";
import TextField from "../Reusable/TextField";
import Button from "../Reusable/Button";
import EmailForm from "../components/EmailComposer/EmailForm";
import Load from "../Icons/StatusIcon/Load";
import { queryClient } from "../root.component";
import {
  Inbox,
  Send,
  FileText,
  Trash2,
  AlertCircle,
  Settings,
  Users,
} from "lucide-react";
import SVGComponent from "../Icons/SwitchAccount";
import AccountSwitcher from "../components/AccountSwitcher";
import useGetAccount from "../hooks/useGetAccount";

let emailFolder: any;
const icons = {
  Inbox: Inbox,
  Sent: Send,
  Deleted: Trash2,
  Drafts: FileText,
  Junk: AlertCircle,
  Settings: Settings,
  Switch: Users,
};
const desiredOrder = [
  "inbox",
  "sent",
  "trash",
  "drafts",
  "junk",
  "settings",
  "switch",
];

export const getEmailFolderId = () => {
  const foldersId: any = {};
  (emailFolder ?? []).forEach((f: any) => {
    foldersId[f?.name?.split(" ")[0]] = f.id;
  });
  return foldersId;
};

const DashboardLayout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [mailData, setMailData] = useState<{
    cc: string[];
    bcc: string[];
    to: string[];
    subject: string;
  }>({ cc: [], bcc: [], to: [], subject: "" });
  const location = useLocation();

  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(setEmailAccountValidationForm),
  });
  const [isOpenSettingPopup, setIsOpenSettingPopup] = useState(false);
  const { data: userData } = useGetHook({
    queryKey: [`me`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  const { data } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.EMAIL}profile/`,
    params: {},
  });
  const id = userData?.id;
  console.log(id, "iddd");

  const { data: accounts, isLoading } = useGetAccount({
    url: APIS.ACCOUNTS,
    queryKey: ["users-accounts"],
    params: {
      user: id,
    },
    enabled: !!id,
  });
  console.log(accounts, "accounts");
  useEffect(() => {
    if (data && data.message === "Mailbox setup doesnt exits") {
      setIsOpenSettingPopup(true);
    }
  }, [data]);
  const { data: folders } = useGetHook({
    queryKey: ["email-folder"],
    url: `${APIS.EMAIL}folder/`,
    params: {
      limit: 10,
      offset: 0,
    },
    interval: 5000,
  });

  emailFolder = folders?.results;

  useMemo(() => {
    emailFolder?.push(
      emailFolder.some((e: any) => e.name === "Settings")
        ? null
        : { id: "f", name: "Settings", role: "settings" }
    );
    if (emailFolder?.[emailFolder?.length - 1] === null) {
      emailFolder.pop();
    }
  }, [folders?.results]);

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["email-folder"],
  });

  const handleSetupEmailAccount = async (values: any, setError: any) => {
    const url = `${APIS.EMAIL}setup/`;
    let formData = {
      ...values,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 200) {
        setIsOpenSettingPopup(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const emailChildren = useMemo(() => {
    return (
      emailFolder?.map((item: any) => ({
        name:
          item.name +
          (item.unread_emails && item.name !== "Sent Items"
            ? ` (${item.unread_emails})`
            : ""),
        role: item.role,
        href: `/mail/${item.id}`,
        icon: icons?.[item?.name.split(" ")[0]] || OverViewIcon,
        activeIcon: icons?.[item?.name.split(" ")[0]] || OverViewIcon,
        unread_emails: item.unread_emails || 0,
      })) || []
    );
  }, [folders?.results]);

  const sortedEmailChildren = useMemo(() => {
    return [...emailChildren].sort((a, b) => {
      const aIndex = desiredOrder.indexOf(a.role);
      const bIndex = desiredOrder.indexOf(b.role);

      return (
        (aIndex === -1 ? Infinity : aIndex) -
        (bIndex === -1 ? Infinity : bIndex)
      );
    });
  }, [emailChildren]);

  const navigation: any = [
    {
      name: "Dashboard",
      href: "",
      icon: "",
      children: sortedEmailChildren,
    },
  ];

  const handleRefresh = async () => {
    await queryClient.refetchQueries();
  };

  const [isOpenPopup, setIsOpenPopup] = useState(false);

  const [isMinimized, setIsMinimized] = useState(false);
  const [isMaximized, setIsMaximized] = useState(false);

  const handleToggleMin = () => {
    if (!isMinimized) {
      setIsMaximized(false);
    }
    setIsMinimized(!isMinimized);
  };

  const handleToggleMax = () => {
    if (!isMaximized) {
      setIsMinimized(false);
    }
    setIsMaximized(!isMaximized);
  };

  const closeNewEmail = () => {
    if (
      mailData.to.length > 0 ||
      mailData.cc.length > 0 ||
      mailData.bcc.length > 0 ||
      mailData.subject
    ) {
      const confirmClose = window.confirm(
        "Are you sure you want to close the email composer? Unsaved changes will be lost."
      );
      if (confirmClose) {
        setIsOpenPopup(false);
        setMailData({ cc: [], bcc: [], to: [], subject: "" });
      } else {
        return;
      }
    } else {
      setIsOpenPopup(false);
      setMailData({ cc: [], bcc: [], to: [], subject: "" });
    }
  };

  return (
    <>
      <DashboardLayoutService navigation={navigation}>
        <div className={tw`p-2 h-[20%] `}>
          <div className={tw`relative`}>
            {location.pathname !== `/mail/${getEmailFolderId()?.Settings}` && (
              <section
                className={tw`flex gap-4 sticky top-0 bg-white mb-2 pl-1 rounded-sm z-1 `}
              >
                <div className={tw`flex flex-row w-full gap-2 py-2  `}>
                  <button
                    className={tw`p-2 w-[10rem] flex gap-x-2 bg-primary-light rounded text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1 text-nowrap`}
                    onClick={() => setIsOpenPopup(true)}
                  >
                    <span
                      className={tw`flex justify-center gap-1 items-center`}
                    >
                      <p className={tw`text-[14px]`}> &#43;</p>
                      <p>New Email</p>
                    </span>
                  </button>
                  <input
                    type="text"
                    placeholder="Search"
                    className={tw`w-full h-9 border-1 border-primary focus:outline-none p-2`}
                    value={searchParams.get("search") || ""}
                    onChange={(e) =>
                      setSearchParams({
                        ...Object.fromEntries(searchParams),
                        search: e.target.value,
                      })
                    }
                  />
                </div>
                <div
                  className={tw`w-12 cursor-pointer flex items-center justify-center`}
                  onClick={handleRefresh}
                >
                  <Load />
                </div>
                {accounts?.length > 1 && (
                  <div
                    className={tw`w-12 cursor-pointer flex items-center justify-center`}
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    <SVGComponent />
                  </div>
                )}
              </section>
            )}
          </div>
          <Outlet />
          {isOpenPopup && (
            <div
              className={tw`${
                isMaximized
                  ? "fixed top-0 left-0 w-full h-full"
                  : isMinimized
                  ? "fixed bottom-0 right-0 w-64 h-20"
                  : "absolute bottom-10 right-1 w-[500px] max-w-[90vw]"
              } z-50 bg-white shadow-xl border border-gray-300 rounded-t-lg flex flex-col`}
            >
              <div
                className={tw`flex justify-between items-center px-2 py-1 bg-gray-100 border-b border-gray-300`}
              >
                <h3 className={tw`font-semibold text-lg`}>New Email</h3>
                <div className={tw`flex items-center gap-2`}>
                  <button
                    onClick={handleToggleMin}
                    className={tw`text-lg hover:text-blue-500`}
                    title={isMinimized ? "Restore" : "Minimize"}
                  >
                    {isMinimized ? "^" : "-"}
                  </button>
                  <button
                    onClick={handleToggleMax}
                    className={tw`text-xl hover:text-blue-500`}
                    title={isMaximized ? "Restore" : "Maximize"}
                  >
                    {isMaximized ? "↓" : "□"}
                  </button>
                  <button
                    onClick={closeNewEmail}
                    className={tw`font-bold text-xl hover:text-red-500`}
                  >
                    ×
                  </button>
                </div>
              </div>
              {!isMinimized && (
                <div
                  className={tw`p-3 flex flex-col gap-2 overflow-y-auto ${
                    isMaximized ? "flex-1" : ""
                  }`}
                >
                  <EmailForm
                    closeNewEmail={() => setIsOpenPopup(false)}
                    isMaximized={isMaximized}
                    setMailData={setMailData}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </DashboardLayoutService>
      <Modal
        isOpen={isOpenSettingPopup}
        setIsOpen={() => console.log()}
        title="Setup Mailbox"
      >
        <div className={tw`py-4 w-[500px]`}>
          <form
            onSubmit={handleSubmit((data) =>
              handleSetupEmailAccount(data, setError)
            )}
            autoComplete="off"
          >
            <TextField
              control={control}
              placeholder="account id"
              name="username"
              label="Account ID"
            />
            <div className={tw`flex items-center justify-end gap-x-4 mt-2`}>
              <div className={tw`w-24`}>
                <Button label="Submit" isLoading={isPostLoading} />
              </div>
            </div>
          </form>
        </div>
      </Modal>
      <Modal title={"Switch Account"} isOpen={isOpen} setIsOpen={setIsOpen}>
        <AccountSwitcher accounts={accounts} isLoading={isLoading} />
      </Modal>
    </>
  );
};

export default DashboardLayout;
